import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TooltipModule } from 'primeng/tooltip';

import { LayoutModule } from '../../Common/Layout/layout.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { JournodexModule } from '../../Common/Journodex/journodex.module';
import { MentionsModule } from '../../Common/Mentions/mentions.module';
import { UsersModule } from '../../Core/Users/users.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { SocialSharedModule } from '../Shared/social-shared.module';

import { SocialRoutingService } from './services/social-routing.service';
import { AgentService } from '../Intelligence/services/agent.service';
import { ThemeService } from '../Intelligence/services/theme.service';
import { SocialSearchService } from './services/social-search.service';

import { SocialComponent } from './components/Social/social.component';
import { NetworkMultiSelectComponent } from './components/NetworkMultiSelect/network-multi-select.component';
import { SocialBlockWrapperComponent } from './components/SocialBlockWrapper/social-block-wrapper.component';

const DECLARATIONS_EXPORTS = [
    SocialComponent,
    NetworkMultiSelectComponent,
    SocialBlockWrapperComponent,
];

@NgModule({
    imports: [
        /* Angular */
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,

        /* Common/Core */
        LayoutModule,
        LocalizationModule,
        CommonDialogsModule,
        MiscModule,
        UsersModule,
        CommonFormsModule,
        JournodexModule,
        MentionsModule,
        CommonBasicModule,

        SocialSharedModule
    ],
    declarations: [
        ...DECLARATIONS_EXPORTS
    ],
    exports: [
        ...DECLARATIONS_EXPORTS
    ],
    providers: [
        SocialRoutingService,
        AgentService,
        ThemeService,
        SocialSearchService,
        {
            provide: 'SocialSearchService',
            useExisting: SocialSearchService
        },
    ]
})
export class SocialCoreModule { }
